import * as React from 'react';

import PropTypes from 'prop-types';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

const offeringShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  offeringType: PropTypes.string,
});

class OfferingLink2 extends React.Component {
  static propTypes = {
    // when this is link is clicked, it will fire an event key made of
    // {group}.{page}.click.{trackingName} (this sets the last part)
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    offering: offeringShape.isRequired,
    children: PropTypes.node.isRequired,
    disableLocalRouting: PropTypes.bool,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'offering' does not exist on type 'Readon... Remove this comment to see the full error message
    const { offering, ...passThroughProps } = this.props;

    return (
      <TrackedLink2
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'offering' does not exist on type 'Readon... Remove this comment to see the full error message
        href={this.props.offering.link}
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        trackingName={this.props.name}
        withVisibilityTracking={true}
        data={{
          id: offering.id,
          target: offering.link,
          offeringType: offering.offeringType,
        }}
        {...passThroughProps}
      />
    );
  }
}

export default OfferingLink2;
